import React, { Fragment } from "react";

import { Dialog, Transition } from "@headlessui/react";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { PRIMARY_BUTTON_CLASS } from "../utils/styles";

export default function LeaveConfirmDialog({ isOpen, onStay, onLeave }) {
  const { t } = useTranslation();
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={onStay}
        id="cert-onboarding-leave-dialog"
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 bg-black/30 backdrop-blur-sm"
            aria-hidden
          />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto p-4">
          <div className="flex min-h-full items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md rounded-2xl border border-cfCardBorder bg-cfSecondary p-6 shadow-2xl">
                <div className="flex items-start gap-4">
                  <div className="shrink-0 w-11 h-11 rounded-full bg-cfWarningBg flex items-center justify-center">
                    <AlertTriangle
                      className="w-5 h-5 text-cfWarningText"
                      aria-hidden
                    />
                  </div>
                  <div className="min-w-0">
                    <Dialog.Title className="text-base font-semibold text-cfHeadingText">
                      {t("certificateOnboarding:html_leave_title")}
                    </Dialog.Title>
                    <Dialog.Description className="mt-1.5 text-sm text-cfGlobalText leading-relaxed">
                      {t("certificateOnboarding:html_leave_body")}
                    </Dialog.Description>
                  </div>
                </div>
                <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
                  <button
                    type="button"
                    onClick={onLeave}
                    id="cert-onboarding-leave-confirm"
                    className="px-4 py-2 border border-cfCardBorder text-cfHeadingText font-medium rounded-md hover:bg-cfCardHover transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimary"
                  >
                    {t("certificateOnboarding:html_leave_confirm")}
                  </button>
                  <button
                    type="button"
                    onClick={onStay}
                    id="cert-onboarding-leave-stay"
                    className={PRIMARY_BUTTON_CLASS}
                  >
                    {t("certificateOnboarding:html_leave_stay")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
